import { Helmet } from "react-helmet-async";
import MainLayout from "../app/layouts/MainLayout";
import {
  About,
  FeaturedProjects,
  Hero,
  Projects,
  Skills,
} from "../components/profile";
import { profileNavLinks } from "../components/profile/navLinks";
import { useSectionReveal } from "../shared/hooks/useSectionReveal";

function Profile() {
  useSectionReveal();

  return (
    <>
      <Helmet>
        <title>
          プロフィール | cocoIT（ココイト）- アプリ開発・Web制作・保守運用
        </title>
        <meta
          name="description"
          content="プロフィール | cocoITは、アプリ開発、Webサイト制作、保守運用を提供します。要件定義から運用まで一貫対応。レスポンシブ対応、SEO最適化、セキュリティ配慮で高品質なソリューションを提供します。"
        />
        <meta
          name="keywords"
          content="アプリ開発,Web制作,保守運用,IT開発,レスポンシブ,SEO,プロフィール"
        />
        <link rel="canonical" href="https://cocoit.jp/profile" />
        <meta
          property="og:title"
          content="プロフィール | cocoIT - アプリ開発・Web制作・保守運用"
        />
        <meta
          property="og:description"
          content="プロフィール | cocoITは、アプリ開発、Webサイト制作、保守運用を提供します。要件定義から運用まで一貫対応。レスポンシブ対応、SEO最適化、セキュリティ配慮で高品質なソリューションを提供します。"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cocoit.jp/profile" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="プロフィール | cocoIT - アプリ開発・Web制作・保守運用"
        />
        <meta
          name="twitter:description"
          content="プロフィール | cocoITは、アプリ開発、Webサイト制作、保守運用を提供します。要件定義から運用まで一貫対応。レスポンシブ対応、SEO最適化、セキュリティ配慮で高品質なソリューションを提供します。"
        />
      </Helmet>
      <MainLayout navLinks={profileNavLinks}>
        <Hero />
        <About />
        <Skills />
        <FeaturedProjects />
        <Projects />
      </MainLayout>
    </>
  );
}

export default Profile;
